import React, { FunctionComponent } from 'react';
import { i18n } from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { hot } from 'react-hot-loader/root';

import PageType from './pages/PageType/PageType';
import { AppProvider } from './context/AppContext';

type AppProps = {
  i18n: i18n;
};

const App: FunctionComponent<AppProps> = ({ i18n }) => (
  <I18nextProvider i18n={i18n}>
    <AppProvider>
      <PageType />
    </AppProvider>
  </I18nextProvider>
);

export default hot(App);
